import styled from '@emotion/styled';
import { Paper, MenuList, MenuItem } from '@mui/material';
import React from 'react';

import { WsTypography, WsTypoVariants } from '../../components/WsTypography';

export interface IWsMenuList {
  startIcon?: boolean;
  menuOptions: string[];
  onItemClick: (option: number) => void;
}

const StyledPaper = styled(Paper)({
  borderRadius: 10,
  paddingY: 1,
  paddingX: 2,
  boxShadow: '0 8 24 rgba(0, 0, 0, 0.1)',
  width: 200,
});

const WsMenuList = ({ menuOptions, onItemClick }: IWsMenuList) => (
  <StyledPaper elevation={3}>
    <MenuList>
      {menuOptions.map((label, index) => (
        <MenuItem key={index} onClick={() => onItemClick(index)}>
          <WsTypography variant={WsTypoVariants.BODY1} cursor="pointer">
            {label}
          </WsTypography>
        </MenuItem>
      ))}
    </MenuList>
  </StyledPaper>
);

export default WsMenuList;
